import { IconButton, Typography } from '@material-ui/core';
import styled from 'styled-components';

import { getIcon } from 'app/components/ErplyIcon';

export const Fields = styled.div<{ $isOpen: boolean; $height: number }>`
  position: relative;
  width: 100%;
  max-width: 21.25rem;
  margin: 0 auto 1.5rem auto;
  padding: 0 0.63rem 0 0.63rem;
  overflow-y: hidden;
  transition: height ease 0.3s;
  height: ${({ $isOpen, $height }) => ($isOpen ? `${$height}px` : '2.85rem')};

  border: 1px solid ${({ theme: { shade } }) => shade['100']};

  > div {
    margin: 1.25rem 0;
    :first-child {
      margin-top: 0.62rem;
    }
  }

  .hardware-list__item,
  .software-list__item {
    color: ${({ theme: { shade } }) => shade['500']};
  }
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: 8.3rem auto;
  font-size: 14px;
  line-height: 20px;
  .field {
    color: ${({ theme }) => theme.shade['500']};
  }
  p {
    font-size: inherit;
    line-height: inherit;
    padding-bottom: 0.63rem;
    :nth-child(even) {
      border-left: 1px solid rgba(0, 0, 0, 0.1);
      padding-left: 1rem;
    }
  }
`;

export const SubFieldLabel = styled(Typography)`
  display: flex;
  flex-flow: row;
  margin-bottom: 0.5rem;
`;

export const ConfirmWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
`;

export const ExpandIcon = styled(IconButton)<{ $isOpen: boolean }>`
  margin-left: auto;
  padding: 0;

  .expand::before {
    font-family: Erply-Icons, serif;
    content: '${({ $isOpen }) =>
      $isOpen ? getIcon('Chevron-Unfold') : getIcon('Chevron-Fold')}';
    font-size: 1.5rem;
  }
`;

export const Icon = styled.span<{ $icon: string }>`
  ::before {
    font-family: Erply-Icons, serif;
    content: '${({ $icon }) => $icon}';
    font-size: 1.5rem;
    margin: 0.3rem 0.3rem 0.3rem 0;
  }
`;
